import type { ComponentStyleConfig } from "@chakra-ui/theme";

const DocumentList: ComponentStyleConfig = {
	baseStyle: {
		wrapper: {
			paddingY: { base: 8 },
		},
		title: {
			color: "brand.blue",
			paddingBottom: 8,
			textAlign: {
				base: "center",
				md: "initial",
			},
		},
		button: {
			fontWeight: "semibold",
		},
		arrow: {
			color: "brand.highlight",
		},
	},
};

export default DocumentList;
